<template>
  <layout-basic>
    <page-hero
      title="Real Businesses. Real Results."
      lead="See how organisations are transforming onboarding, compliance and employee development."
    />

    <section class="demo-video-section">
      <v-container style="max-width: 960px">
        <demo-video video-key="stories" />
      </v-container>
    </section>

    <!-- Trilogy Active, the first named customer story (Steve, 16 Sep 2026):
         the facts he supplied and the quote, verbatim. -->
    <section class="stories-featured">
      <v-container>
        <article class="stories-featured__card">
          <p class="stories-featured__eyebrow">Customer story</p>
          <h2 class="font-sora stories-featured__name">{{ story.company }}</h2>
          <p class="stories-featured__meta">
            <span>{{ story.sector }}</span>
            <span class="stories-featured__sep" aria-hidden="true">·</span>
            <span>{{ story.facts }}</span>
          </p>
          <blockquote class="stories-featured__quote">“{{ story.quote }}”</blockquote>
          <p class="stories-featured__attrib">
            <strong>{{ story.attribution }}</strong><br />{{ story.role }}
          </p>
        </article>
      </v-container>
    </section>

    <!-- Steve, 18 Sep 2026: no "case study coming soon" placeholders; the
         genuine testimonials (the same carousel as Pricing) until the full
         sector case studies exist. The charity and renewal quotes that lived
         in the sector cards follow as a quote row so nothing is lost. -->
    <testimonial-carousel
      title="What our customers say"
      lead="Real feedback from organisations using IMPROVE today."
    />
    <quote-row :quotes="pageQuotes" />

    <standard-cta
      title="Could your business be next?"
      lead="Watch the 4-minute demo or experience IMPROVE for yourself."
    />
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import PageHero from '@/components/marketing/PageHero.vue';
import StandardCta from '@/components/marketing/StandardCta.vue';
import DemoVideo from '@/components/DemoVideo.vue';
import TestimonialCarousel from '@/components/marketing/TestimonialCarousel.vue';
import QuoteRow from '@/components/marketing/QuoteRow.vue';
import { marketingPageMeta } from '@/utils/marketingPage';
import {
  TRILOGY_STORY,
  TRILOGY_RENEWED,
  CHARITY_VALUE_FOR_MONEY,
  CHARITY_LEARNING_PATHWAYS,
} from '@/data/testimonials';

export default {
  name: 'CustomerStories',
  components: {
    LayoutBasic,
    PageHero,
    StandardCta,
    DemoVideo,
    TestimonialCarousel,
    QuoteRow,
  },
  metaInfo() {
    return marketingPageMeta({
      title: 'Real Businesses. Real Results. | IMPROVE',
      description:
        'See how organisations are transforming onboarding, compliance and employee development with IMPROVE.',
      path: '/customer-stories',
    });
  },
  data() {
    return {
      story: TRILOGY_STORY,
      // The two charity quotes from Steve's 16 Sep brief were headed "Charity
      // Sector Page"; there are no sector pages and he wants no new ones, so
      // they sit under the carousel here. Trilogy's renewal quote likewise.
      pageQuotes: [CHARITY_VALUE_FOR_MONEY, CHARITY_LEARNING_PATHWAYS, TRILOGY_RENEWED],
    };
  },
};
</script>

<style scoped>
.stories-featured {
  padding: 8px 0 24px;
}

.stories-featured__card {
  max-width: 900px;
  margin: 0 auto;
  background: #fff;
  border: 1px solid #e6ebf1;
  border-radius: 14px;
  padding: 32px 36px;
  box-shadow: 0 12px 40px rgba(0, 36, 88, 0.06);
  text-align: center;
}

.stories-featured__eyebrow {
  margin: 0 0 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--brand-teal, #08a0a8);
}

.stories-featured__name {
  margin: 0 0 6px;
  font-size: 28px;
  font-weight: 700;
  color: var(--brand-navy, #002458);
}

.stories-featured__meta {
  margin: 0 0 18px;
  color: var(--brand-grey, #6b7280);
  font-size: 14px;
}

.stories-featured__sep {
  margin: 0 8px;
}

.stories-featured__quote {
  margin: 0 auto 14px;
  max-width: 760px;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.45;
  color: var(--brand-navy, #002458);
}

.stories-featured__attrib {
  margin: 0;
  font-size: 14px;
  line-height: 1.45;
  color: var(--brand-grey, #6b7280);
}

.stories-featured__attrib strong {
  color: var(--brand-navy, #002458);
}


</style>
